import Vuetify from 'vuetify/lib'
import 'material-design-icons-iconfont/dist/material-design-icons.css'

export default Vue => {
  Vue.use(Vuetify)
  const opts = {}
  return new Vuetify(opts)
}
